module.exports = __webpack_public_path__ + "font_anzu.10404826.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/parent_to_child/font_anzu.png
// module id = Bqpq
// module chunks = 0